
export const experience = [
    {
        interval: 'Июль 2021 — по настоящее время',
        company: 'АО «Паспорт.Цифровые продукты» (АО «П.ЦП»)',
        position: 'Frontend - разработчик',
        url: 'https://ppdp.ru/',
        list_1: [
            'Разрабатываю сложные пользовательские интерфейсы, формы с более 100 взаимозависимыми полями, таблицы с большим количеством логики;',
        'Занимаюсь оптимизацией библиотеки компонентов, ускоряю рендер компонентов и скорость их работы, а также добавляю новые;',
        'Переписывал проекты на typescript и рефакторил код всего web-сервиса;',
        'Провожу код-ревью и наставничество младших разработчиков;',
        'Писал документацию для проекта а также bash-скрипты для разворачивания и сборки;',
        'Работал с библиотекой i18next, а также занимался оптимизацией переводов;'
        ],
        list_2: [
            'Внедрил компонент ErrorBoundary;',
            'Написал скрипт для парсинга полей Java-классов из backend в typescript интерфейсы, что позволило frontend-команде создавать новые типы на порядок быстрее;',
            'Аргументировал необходимость Storybook и занимаюсь его разработкой.'
        ],
        // list_3: [
        //     'Стек: React, Redux, Redux-thunk, react-final-form, primereact, primeflex, webpack, eslint.\n'
        // ]
    },
    {
        interval: 'Октябрь 2022 — по настоящее время',
        company: 'VK Образование',
        position: 'Ментор по UX / UI',
        url:  'https://education.vk.company/',
        list_1: [
            'Проверка ДЗ студентов.'
        ],
        list_2: [
            'Уже 2-ой семестр являюсь наставником студентов по курсу "Проектирование интерфейсов";',
            'Помогаю конструировать правильный UI;',
            'Помогаю рисовать макеты в Figma.'
        ],
        list_3: [
            'Внес в курс такую очевидную вещь как прелоудеры и лоудеры.'
        ]
    },
    {
        interval: 'Февраль 2022 — май 2022',
        company: 'VK Образование',
        position: 'Ментор по С/C++',
        url:  'https://education.vk.company/',
        list_1: [
            'Проверка ДЗ студентов;',
            'Помощь студентам в тайм-менеджменте;',
            'Ведение ведомости по успеваемости.'
        ],
        list_2: [
         'Был наставником 4 команд;',
         'Проверял домашние задания и ревьюил код;',
         'Проводил дополнительные внеучебные конференции;',
         'Давал советы по реализации командного проекта - приложения на C++.'
        ],
        list_3: [
            'На курс поступило 170 человек, выпустилось 14, из них 7 моих студентов.'
        ]
    },
    {
        interval: 'Июль 2020 — Июнь 2021',
        company: 'Детский центр "Шаробот"',
        position: 'Преподаватель по программированию',
        url: 'https://sharobot.ru/msk',
        list_1: [
           'Проведение занятий по программированию на Python;',
            'Создание интерактивных задач на Python.'
        ],
        list_2: [
           'Прививал детям любовь к программированию, добился 90%-ой посещаемости на 100%-ой вовлеченности на моих занятиях;',
           'Создал внутреннюю базу данных клиентов и перевел часть документооборота в цифровой формат.'
        ],
        list_3: [
        ]
    }
]

const contacts = [
    {
        name: 'telegram',
        icon: 'fwefwef',
        url: 'https://t.me/Mars_444'
    },
    {
        name: 'github',
        icon: 'fwefwef',
    },
    {
        name: 'linkedin',
        icon: 'fwefwef',
    },
]


const social =  [
        {
            name: 'Telegram',
            url: 'https://t.me/Mars_444',
        },
        {
            name: 'GitHub',
            url: 'https://github.com/mars444',
        },
        {
            name: 'Linkedin',
            url:
                'https://www.linkedin.com/in/%D0%BF%D0%B5%D1%82%D1%80-%D0%BF%D0%B0%D0%BC%D1%83%D0%B6%D0%B0%D0%BA-09799a107/',
        },
    ]

    export const navLinks = [

    {
        label: 'Обо мне',
        // url: '/#about',
        url: '#about',
    },
    {
        label: 'Образование',
        // url: '/#education',
        url: '#education',
    },
    {
        label: 'Опыт работы',
        // url: '/#experience',
        url: '#experience',
    },

    {
        label: 'Контакты',
        // url: '/#contact',
        url: '#contact',
    },
]

const  colors = {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
}

export const email = 'petr@pamuzhak.ru'